import { useEffect, useMemo } from 'react';
import { WidgetDataAttr, WidgetLocation } from '@/types/widget';
import { SENTRY_CONTEXT_KEYS, setSentryContext } from '@/utils/sentry';

const useWidgetDataAttr = (): WidgetDataAttr => {
  const scriptTag = document.querySelector(
    'script[data-companyid]',
  ) as HTMLScriptElement;

  // Extract configuration from data attributes
  const widgetDataAttr = useMemo(
    () => ({
      companyId: scriptTag.getAttribute('data-companyid'),
      location: scriptTag.getAttribute('data-location') as WidgetLocation,
      widgetId: scriptTag.getAttribute('data-widgetid'),
      env: scriptTag.getAttribute('data-env') || 'production',
    }),
    [scriptTag],
  );

  useEffect(() => {
    if (widgetDataAttr) {
      setSentryContext(SENTRY_CONTEXT_KEYS.WIDGET, widgetDataAttr);
    }
  }, [widgetDataAttr]);

  return widgetDataAttr;
};

export default useWidgetDataAttr;
